class GrpcConfig {
  constructor() {
    this.config = {
      host: "/gwg",
      meta: {
        "X-ProfileId": "",
        "X-Locale": "",
      },
    };
  }
  getConfig() {
    return this.config;
  }
  setHost(host) {
    this.config.host = host;
  }
  setProfileIdHeader(profile_id = "") {
    this.config.meta["X-ProfileId"] = profile_id;
  }
  /**
   * Set X-Locale header
   * @param {string} lang
   */
  setXLocaleHeader(lang) {
    this.config.meta["X-Locale"] = lang;
  }
}
export default new GrpcConfig();
